export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Microsoft Certified: Azure Fundamentals',
            details : 'Achieved Microsoft Azure Fundamentals certification, validating foundational knowledge of cloud services and Azure offerings.',
            date : '2025',
            field : 'Cloud',
            image : 'https://learn.microsoft.com/en-us/media/learn/certification/badges/microsoft-certified-fundamentals-badge.svg'
        },
        {
            id : 2,
            title : 'Problem Solving (Basic)',
            details : 'Achieved Certificate in Problem Solving (Basic) in Data Structures and Algorithms by Hacker Rank',
            date : '2021',
            field : 'DSA',
            image : 'https://cdn.cdo.mit.edu/wp-content/uploads/sites/67/2019/09/hackerrank-1.jpg'
        },
        {
            id : 3,
            title : '2nd prize in competition',
            details : '2nd Prize in building Tower of cards, GNIT (Mullana), 2016',
            date : '2016',
            field : 'General',
            image : 'https://i.pinimg.com/originals/2d/e9/44/2de944d6056fa4b6fd65d6c97c12ba7e.jpg'
        }
    ]
}
